import { Box } from '@mui/material';
import usePageTitle from 'hooks/usePageTitle';
import Tabs, { ITab } from 'DesignSystem/Primitives/Tabs/Tabs';
import React, { FC } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import PageContainer from 'Components/PageContainer';
import PageTitle from 'Components/PageTitle';

type TabType = 'active' | 'archived';

const SUPPLY_CHAIN_TABS: ITab[] = [
  {
    key: 'active',
    label: 'Supply chains',
  },
  {
    key: 'archived',
    label: 'Archived supply chains',
  },
];

const SupplyChainLayout: FC = () => {
  usePageTitle('Supply Chains');
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const selectedTab: TabType = pathname.split('/')[2] as TabType;

  const handleChangeTab = (tab: string) => {
    navigate(`/supply-chains/${tab}`);
  };

  return (
    <PageContainer>
      <PageTitle title="Supply Chains" />

      <Box mt={3} mb={1}>
        <Tabs tabs={SUPPLY_CHAIN_TABS} selectedTab={selectedTab} onChange={handleChangeTab} />
      </Box>

      <Outlet />
    </PageContainer>
  );
};

export default SupplyChainLayout;
